$(document).ready(function () {
    $('body').TopBtn();
    $('.toggle-caution').Folding({open: true});

    pageMain.init();
});

const pageMain = (function(){
    let contentTop = $('.contents').offset().top;
    let init = ()=>{
        quick();
        video();
        $(document).on('click', '.p-btn__click-scroll, .quick__item--1, .p-nav__item--1 .p-nav__link', ()=>{
            $('html, body').stop().animate(
                {
                    scrollTop: contentTop
                }, {
                    duration: 500,
                }
            );
        });

        $(document).on('mouseenter', '.p-nav__link', function(){
            $(this).addClass('p-nav__link--on');
            $(this).find('.p-nav__bg').addClass('p-nav__bg--on');
        });
        $(document).on('mouseleave', '.p-nav__link', function (){
            $(this).removeClass('p-nav__link--on');
            $('.p-nav__bg').removeClass('p-nav__bg--on');
        });
    };
    let quick = ()=>{
        let scltop = $(window).scrollTop();

        if (!(contentTop <= scltop)) $('.quick__item--1').removeClass('quick__item--on');
        $(window).scroll(function(){
            var scltop = $(window).scrollTop();
            if (contentTop <= scltop) {
                $('.quick__item--1').addClass('quick__item--on');
            }
            if (!(contentTop <= scltop)) $('.quick__item--1').removeClass('quick__item--on');
            if (scltop >= contentTop) $('.quick').addClass('fix');
            else $('.quick').removeClass('fix');
        });
    };
    let video = ()=>{
        let flag;
        let _video = new nc.promokit.Player({
            selector: '#player-1',
            videoId: 'MQEP1rF7_J0',
            mute: false,
            controls: true,
            coverClick: false,
            loop: true,
        });
        _video.on('canplay', ()=>{
            flag = true;
        });

        let _layer  = new nc.promokit.Layer({
            el: "#layer-video",
            fade: true,
            esc: true,
            dim: true,
            dimClickClose: true
        });
        _layer.on('layercloseend', ()=>{
            _video.pause();
        });

        $(document).on('click', '.p-btn__layer-video', ()=>{
            _layer.open();
            if( flag ) _video.play();
        });
        $(document).on('click', '.layer__close', ()=>{
            _layer.close();
        })
    };
    return{
        init: init
    }
})();




// WEBPACK FOOTER //
// ./src/js/intro.js